import { render, staticRenderFns } from "./RoomGallery.vue?vue&type=template&id=29646202&"
import script from "./RoomGallery.vue?vue&type=script&lang=js&"
export * from "./RoomGallery.vue?vue&type=script&lang=js&"
import style0 from "./RoomGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports